import $ from 'jquery';
import BaseView from 'picnic/core/views/Base';
import {i18next} from 'picnic/core/utils/i18next';


const
	SELECTOR_FILTER = '.filter',
	TEXT_OPTION_DEFAULT = i18next.t('Choose'),
	TEXT_MONTH = i18next.t('Month'),
	TEXT_YEAR = i18next.t('Year')
;


class View extends BaseView {

	render() {
		super.render();

		// Build years and months arrays
		this.$el.find('a').each((index, el) => {
			const
				month = el.innerText.replace(/ \/ \d{4}$/, ''),
				year = el.innerText.replace(/^\d{2} \/ /, '')
			;

			year === this.currentYear && !this.months.includes(month) && this.months.push(month);
			!this.years.includes(year) && this.years.push(year);
		});
		this.months.sort();
		this.years.reverse();

		// Add years select
		this.years.length && this._initSelect({
			active: this.currentYear,
			name: TEXT_YEAR,
			options: this.years,
			selector: 'years'
		});

		// Add months select
		this.currentYear && this._initSelect({
			active: this.currentMonth,
			name: TEXT_MONTH,
			options: this.months,
			selector: 'months'
		});

		return this;
	}

	events() {
		return {
			'change .months': '_onChangeMonths',
			'change .years': '_onChangeYears'
		};
	}

	get currentMonth() {
		this._currentMonth = this._currentMonth || this.$el.data('current-month')?.toString();
		return this._currentMonth;
	}

	get currentYear() {
		this._currentYear = this._currentYear || this.$el.data('current-year')?.toString();
		return this._currentYear;
	}

	get months() {
		this._months = this._months || [];
		return this._months;
	}

	get url() {
		this._url = this._url || this.$el.data('url');
		return this._url;
	}

	get years() {
		this._years = this._years || [];
		return this._years;
	}

	_initSelect({active, name, options, selector}) {
		const $select = $(`
			<label>
				<span class="label">${name}</span>
				<span class="field">
					<select class="${selector}" id="${selector}">
						<option>${TEXT_OPTION_DEFAULT}</option>
						${options.map(el => `<option value="${el}"${active && active === el ? ' selected' : ''}>${el}</option>`)}
					</select>
				</span>
			</label>
		`);

		this.$el.find(SELECTOR_FILTER).append($select);
		return $select;
	}

	_onChangeMonths({currentTarget}) {
		const value = $(currentTarget).val();
		window.location.href = `${this.url}${this.currentYear}/${value !== TEXT_OPTION_DEFAULT ? `${value}/` : ''}`;
	}

	_onChangeYears({currentTarget}) {
		const value = $(currentTarget).val();
		window.location.href = `${this.url}${value !== TEXT_OPTION_DEFAULT ? `${value}/` : ''}`;
	}

}

export default View;
